import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_CATEGORIES, GET_RECENT_POSTS } from '../../graphql/queries';

const Sidebar = () => {
    const publicUrl = process.env.PUBLIC_URL + '/';

    // Fetch categories
    const { data: categoriesData } = useQuery(GET_CATEGORIES);
    const categories = categoriesData?.categories?.nodes?.slice(0, 6) || [];

    // Fetch recent posts
    const { data: recentPostsData } = useQuery(GET_RECENT_POSTS, {
        variables: { first: 3 }
    });
    const recentPosts = recentPostsData?.posts?.nodes || [];

    // Helper function to format date
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    };

    return (
        <div className="category-sitebar">
            {/* Categories Widget */}
            <div className="widget widget-category">
                <h6 className="widget-title">Categories</h6>
                <div className="row custom-gutters-14">
                    {categories.map((category, index) => (
                        <div className="col-lg-6 col-sm-6" key={category.id}>
                            <div className="single-category-inner">
                                <img src={publicUrl + `assets/img/category/${9 + index}.png`} alt={category.name} />
                                <Link className="tag-base tag-blue" to={`/category/${category.slug}`}>
                                    {category.name}
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Advertisement Widget */}
            <div className="widget widget-add">
                <div className="add">
                    <img className="w-100" src={publicUrl + "assets/img/add/3.png"} alt="img" />
                </div>
            </div>

            {/* Social Widget */}
            <div className="widget widget-social">
                <h6 className="widget-title">Join to Us</h6>
                <ul className="social-area social-area-2">
                    <li><a className="facebook-icon" href="#"><i className="fa fa-facebook" /></a></li>
                    <li><a className="twitter-icon" href="#"><i className="fa fa-twitter" /></a></li>
                    <li><a className="youtube-icon" href="#"><i className="fa fa-youtube-play" /></a></li>
                    <li><a className="instagram-icon" href="#"><i className="fa fa-instagram" /></a></li>
                    <li><a className="google-icon" href="#"><i className="fa fa-google-plus" /></a></li>
                </ul>
            </div>

            {/* Recent Posts Widget */}
            <div className="widget">
                <h6 className="widget-title">Recent Posts</h6>
                <div className="trending-post">
                    {recentPosts.map((post) => (
                        <div className="single-post-wrap style-overlay" key={post.id}>
                            <div className="thumb">
                                <img
                                    src={post.featuredImage?.node?.sourceUrl || publicUrl + "assets/img/post/5.png"}
                                    alt={post.title}
                                />
                            </div>
                            <div className="details">
                                <div className="post-meta-single">
                                    <p><i className="fa fa-clock-o" />{formatDate(post.date)}</p>
                                </div>
                                <h6 className="title">
                                    <Link
                                        to={`/blog/${post.slug}`}
                                        dangerouslySetInnerHTML={{ __html: post.title }}
                                    />
                                </h6>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Popular Posts Tab Widget */}
            <div className="widget">
                <div className="nxp-tab-inner nxp-tab-post-two mb-4">
                    <ul className="nav nav-tabs" id="nx1" role="tablist">
                        <li className="nav-item" role="presentation">
                            <a className="nav-link active" id="nx1-tab-1" data-toggle="pill" href="#nx1-tabs-1" role="tab" aria-selected="true">
                                Recent
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a className="nav-link" id="nx1-tab-2" data-toggle="pill" href="#nx1-tabs-2" role="tab" aria-selected="false">
                                Popular
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="tab-content" id="nx1-content">
                    <div className="tab-pane fade show active" id="nx1-tabs-1" role="tabpanel">
                        {recentPosts.map((post, index) => (
                            <div className={`single-post-list-wrap ${index === recentPosts.length - 1 ? 'mb-0' : ''}`} key={post.id}>
                                <div className="media">
                                    <div className="media-left">
                                        <img
                                            src={post.featuredImage?.node?.sourceUrl || publicUrl + `assets/img/post/list/${index + 1}.png`}
                                            alt={post.title}
                                        />
                                    </div>
                                    <div className="media-body">
                                        <div className="details">
                                            <div className="post-meta-single">
                                                <ul>
                                                    <li><i className="fa fa-clock-o" />{formatDate(post.date)}</li>
                                                </ul>
                                            </div>
                                            <h6 className="title">
                                                <Link
                                                    to={`/blog/${post.slug}`}
                                                    dangerouslySetInnerHTML={{ __html: post.title }}
                                                />
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="tab-pane fade" id="nx1-tabs-2" role="tabpanel">
                        {recentPosts.map((post, index) => (
                            <div className={`single-post-list-wrap ${index === recentPosts.length - 1 ? 'mb-0' : ''}`} key={post.id}>
                                <div className="media">
                                    <div className="media-left">
                                        <img
                                            src={post.featuredImage?.node?.sourceUrl || publicUrl + `assets/img/post/list/${index + 1}.png`}
                                            alt={post.title}
                                        />
                                    </div>
                                    <div className="media-body">
                                        <div className="details">
                                            <div className="post-meta-single">
                                                <ul>
                                                    <li><i className="fa fa-clock-o" />{formatDate(post.date)}</li>
                                                </ul>
                                            </div>
                                            <h6 className="title">
                                                <Link
                                                    to={`/blog/${post.slug}`}
                                                    dangerouslySetInnerHTML={{ __html: post.title }}
                                                />
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Newsletter Widget */}
            <div className="widget">
                <form className="single-newsletter-inner bg-blue text-center">
                    <h5>Newsletter</h5>
                    <p>Stay Updated on all that's new add noteworthy</p>
                    <div className="single-input-inner">
                        <input type="text" placeholder="Enter Your Name" />
                    </div>
                    <div className="single-input-inner">
                        <input type="text" placeholder="Enter Your Email" />
                    </div>
                    <a className="btn btn-white w-100" href="#">Subscribe Now</a>
                </form>
            </div>
        </div>
    );
};

export default Sidebar;
